import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'

import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'
import * as tutorialSelectors from '../tutorial.selectors'
import * as tutorialActions from '../tutorial.actions'

import AnswerBattle from '../../Mars/Battles/AnswerBattle/AnswerBattle'

const mapDispatchToProps = (dispatch) => ({
  answerBattleQuestion: bindActionCreators(tutorialActions.answerBattleQuestion, dispatch),
  giveUp: bindActionCreators(tutorialActions.noop, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})
const mapStateToProps = (state) => ({
  info: tutorialSelectors.getBattleInfoFromState(state),
  currentQuestion: tutorialSelectors.getCurrentBattleQuestion(state),
  individualBattle: tutorialSelectors.getIndividualBattle(state),
  battle: tutorialSelectors.getCurrentBattle(state),
  userInfo: tutorialSelectors.getCurrentUser(state),
  loading: false,
  hideTabs: tutorialSelectors.getPhase1HideUI(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AnswerBattle))
